import { ProgramNames } from '../../../models'
import { ProgramCustomerPropertyId } from '../../common/constants/customerProgram'
import { TREATMENT_OPTIONS } from '../../common/constants/treatmentOptions'
import { ProgramDisplayLabels } from '../messages'
import { ProgramConfig } from '../types'

export const SELF_CARE_APPS_PROGRAM = {
  programName: ProgramNames.SELF_CARE_APPS,
  blendedCareProgramId: null,
  customerPropertyId: ProgramCustomerPropertyId.mystrength_accesscode,

  displayLabels: {
    default: ProgramDisplayLabels.guidedSelfCare,
    clientProfile: 'Guided self-care coaching',
    sessionSummary: 'guided self care',
  },

  associatedProviderTypes: [],
  associatedProviderModalities: [],

  canRescheduleAppointment: false,
  selfPayEligible: false,

  treatmentOptionProperties: {
    associatedTriageTreatmentOptions: [TREATMENT_OPTIONS.SELF_CARE_APPS],
    isFullTreatmentOption: true,
  },

  consents: [],

  questionIdentifiers: {
    SI_QUESTION: 'phq9_9',
    SI_PLAN_QUESTION: 'phq9_9_1',
    SI_INTENT_QUESTION: 'phq9_9_2',
  },
} satisfies ProgramConfig
